import React, {useEffect, useState} from 'react';
import {
    Box,
    Grid,
    List,
    CardContent,
    Typography,
    IconButton,
    ListItem,
    useToastProvider
} from '@deere/fuel-react';
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {useStyles} from "../shared/styles/Ratings";
import {useAuthConfig} from "../shared/helper";
import {AccordionDetails} from '@material-ui/core';
import {RatingsActions} from "./RatingsActions";
import {RatingsGeneralComments} from './RatingsGeneralComments';
import VisibilityIcon from '@material-ui/icons/Visibility';
import {COMMENT_VISIBLE_TITLE} from "../shared/Constants";
import {RatingsAddComment} from "./RatingsAddComment";
import {RatingCommentDisplay} from "./RatingCommentDisplay";

export const RatingsCategoryComments = ({
                                            categoryId,
                                            generalComments,
                                            isActionsAllowed,
                                            suppliers,
                                            isSupplierMimic,
                                            userInfo,
                                            categoryComments,
                                            updateVisibilityState,
                                            ratingPeriod
                                        }) => {
    const classes = useStyles();
    const authAxios = useAuthConfig();
    const {enqueueToast} = useToastProvider();
    const [expanded, setExpanded] = useState('panel0');
    const [comments, setComments] = useState([]);
    const [filteredSuppliers, setFilteredSuppliers] = useState([]);
    const [commentsLength, setCommentsLength] = useState(0);
    const [anchorEl, setAnchorEl] = useState(null);
    const [expandedComments, setExpandedComments] = useState('panel1');
    const [isAddCommentOpen, setIsAddCommentOpen] = useState(false);
    const [isEditCommentOpen, setIsEditCommentOpen] = useState(false);
    const [categoryCommentsData, setCategoryCommentsData] = useState([]);
    const loggedInUser = userInfo && userInfo.userId;
    const [isCommentAvailable, setIsCommentAvailable] = useState(false)
    const [categoryComment, setCategoryComment] = useState('');
    let commentsCount = "";

    const handleClose = () => {
        setAnchorEl(null);
    };

    const isCurrentPeriod = ratingPeriod.fiscalYear === "current";

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : 'panel0');
    };

    const handleChangeComment = (panel) => (event, newExpanded) => {
        setExpandedComments(newExpanded ? panel : 'panel1');
    };

    const handleCategoryComments = (type, categoryId) => {
        if (type === "add") {
            setIsAddCommentOpen(true)
            setIsEditCommentOpen(false)
        } else {
            setIsAddCommentOpen(false)
            setIsEditCommentOpen(true)
        }
        setExpanded(`panel${categoryId}`)
    }

    const handleGeneralCommentsUpdate = (type, data) => {
        updateVisibilityState(type, data)
    }

    const handleCommentsAction = (value, categoryId, type, commentId) => {
        if (type === "save") {
            let data = {
                comment: value,
                supplierNumbers: suppliers.map(item => item.supplierNumber),
                categoryId: categoryId
            }
            authAxios.post(`/ratingCategoryComment`, data)
                .then(res => {
                    updateVisibilityState("categoryComment-save", res.data)
                    setIsEditCommentOpen(false)
                    setIsAddCommentOpen(false)
                    enqueueToast({
                        variant: "success",
                        title: "Category Comment Saved Successfully",
                        isCloseable: true
                    });
                }).catch((e) => {
                enqueueToast({
                    variant: "error",
                    title: "Error saving comment",
                    message: e.response ? e.response.data[e.response.status.toString()] : "",
                    isPersistent: true
                });
            })
        }
        if (type === "update") {
            let data = {
                comment: value,
                categoryId: categoryId,
                isCommentVisible: categoryComments.filter(item => item.id === commentId)[0].isCommentVisible,
                visibilityUpdate: false,
                supplierNumbers: suppliers.map(item => item.supplierNumber)
            }
            authAxios.put(`/ratingCategoryComment/${commentId}`, data)
                .then(res => {
                    updateVisibilityState("categoryComment-update", res.data)
                    setIsEditCommentOpen(false)
                    setIsAddCommentOpen(false)
                    enqueueToast({
                        variant: "success",
                        title: "Category Comment Updated Successfully",
                        isCloseable: true
                    });
                }).catch((e) => {
                enqueueToast({
                    variant: "error",
                    title: "Error updating comment",
                    message: e.response ? e.response.data[e.response.status.toString()] : "",
                    isPersistent: true
                });
            })
        }
        if (type === "delete") {
            authAxios.delete(`/ratingCategoryComment/${commentId}`)
                .then(res => {
                    updateVisibilityState("categoryComment-delete", res.data)
                    setIsEditCommentOpen(false)
                    setIsAddCommentOpen(false)
                    enqueueToast({
                        variant: "success",
                        title: "Category Comment Deleted Successfully",
                        isCloseable: true
                    });
                }).catch((e) => {
                enqueueToast({
                    variant: "error",
                    title: "Error deleting comment",
                    message: e.response ? e.response.data[e.response.status.toString()] : "",
                    isPersistent: true
                });
            })
        }
        if (type === "cancel") {
            setIsAddCommentOpen(false)
            setIsEditCommentOpen(false)
        }
        if (type === "edit-click") {
            setIsEditCommentOpen(true)
        }
        if (type === "update-visibility") {
            let data = {
                categoryId: categoryId,
                id: commentId,
                isCommentVisible: value,
                visibilityUpdate: true,
                supplierNumbers: suppliers.map(item => item.supplierNumber)
            }
            authAxios.put(`/ratingCategoryCommentVisibility`, data)
                .then(res => {
                    updateVisibilityState("categoryComment-updateVisibility", res.data)
                    setIsEditCommentOpen(false)
                    setIsAddCommentOpen(false)
                    enqueueToast({
                        variant: "success",
                        title: "Category Comment Updated Successfully",
                        isCloseable: true
                    });
                }).catch((e) => {
                enqueueToast({
                    variant: "error",
                    title: "Error updating comment",
                    message: e.response ? e.response.data[e.response.status.toString()] : "",
                    isPersistent: true
                });
            })
        }
    }

    useEffect(() => {
        const filteredComments = generalComments.filter(ele => {
            return ele.comments.length !== 0
        })
        const categorySupplierComments = [...new Set(filteredComments.map(item => item.comments.filter(comment => parseInt(comment.categoryId) === categoryId)).flat())]
        const mappedCommentsSuppliers = [...new Set(filteredComments.map(ele => ele.supplierNumber))]
        const filterSuppliers = suppliers.filter(item => mappedCommentsSuppliers.includes(item.supplierNumber))
        const categoryCommentsList = categoryComments && categoryComments.filter(item => parseInt(item.categoryId) === categoryId)

        setCategoryCommentsData(categoryCommentsList)
        setFilteredSuppliers(filterSuppliers)
        setComments(filteredComments)

        let criteriaCommentsData = (isActionsAllowed && !isSupplierMimic) ? categorySupplierComments.length : categorySupplierComments.filter(item => item.isCommentVisible).length
        let categoryCommentsData = (isActionsAllowed && !isSupplierMimic) ? (categoryCommentsList ? categoryCommentsList.length : 0) : (categoryCommentsList ? categoryCommentsList.filter(item => item.isCommentVisible).length : 0)

        setCommentsLength(criteriaCommentsData + categoryCommentsData)

        return () => {
            setCategoryCommentsData([])
            setComments([])
            setCommentsLength(0)
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [generalComments, categoryComments, categoryId, isSupplierMimic]);

    useEffect(() => {
        const categoryCommentsList = categoryComments && categoryComments.filter(item => {
            return parseInt(item.categoryId) === categoryId && (Object.keys(item.user).length !== 0 && item.user.racfID?.toUpperCase() === loggedInUser?.toUpperCase())
        })

        if (categoryCommentsList && categoryCommentsList.length > 0) {
            setIsCommentAvailable(true)
            setCategoryComment(categoryCommentsList[0])
        } else
            setIsCommentAvailable(false)
    }, [categoryComments, categoryId, loggedInUser]);

    return (
        <CardContent
            style={{padding: 0, marginTop: 10}}>
            <div className={classes.root}>
                <Accordion expanded={expanded === `panel${categoryId}`}
                           onChange={(commentsLength && commentsLength !== 0) ? handleChange(`panel${categoryId}`) : () => {
                           }}>
                    <Grid container alignItems="center">
                        <Grid item xs={12} md={8}>
                            <AccordionSummary
                                className={classes.accordionSummary}
                                classes={{
                                    expandIcon: classes.expandIcon,
                                    content: classes.content,
                                    expanded: classes.expanded
                                }}
                                expandIcon={<ExpandMoreIcon/>}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                                IconButtonProps={commentsLength === 0 ? {className: classes.btn} : {}}>
                                <Box display="flex"
                                     justifyContent="flex-start"
                                     alignItems="center">
                                    <Typography
                                        color="primary" size="md"
                                        style={commentsLength === 0 ? {paddingLeft: '10px'} : {paddingLeft: '0px'}}>
                                        Category Comments
                                    </Typography>
                                </Box>
                            </AccordionSummary>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Box display="flex" pr={2}>
                                <Grid container alignItems="center">
                                    <Grid item xs={(isActionsAllowed || (isCurrentPeriod && (userInfo.isSupplier || isSupplierMimic))) ? 11 : 12}>
                                        <Box display="flex"
                                             justifyContent="flex-end"
                                             pr={(isActionsAllowed || (isCurrentPeriod && (userInfo.isSupplier || isSupplierMimic))) ? 0 : 4}>
                                            <Typography color="tertiary" size="sm">
                                                {commentsLength} {commentsLength === 1 ? 'Comment' : 'Comments'}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    {(isActionsAllowed || (isCurrentPeriod && (userInfo.isSupplier || isSupplierMimic))) &&
                                    <Grid item xs={1}>
                                        <RatingsActions
                                            onClose={handleClose}
                                            onActionsClick={handleClick}
                                            anchorEl={anchorEl}
                                            onCategoryCommentClick={handleCategoryComments}
                                            isComments={true}
                                            categoryId={categoryId}
                                            isCommentsEdit={isCommentAvailable}/>
                                    </Grid>
                                    }
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                    <AccordionDetails className={classes.accordionDetails}>
                        {suppliers.length === 1 ?
                            <Grid container alignItems="center">
                                {isAddCommentOpen &&
                                <Grid item xs={12}>
                                    <Box style={{padding: "0 2.25rem 1rem 3rem"}} display="flex" alignContent="center">
                                        <RatingsAddComment
                                            placeholder=""
                                            criteriaId={categoryId}
                                            onCommentsAction={handleCommentsAction}
                                        />
                                    </Box>
                                </Grid>
                                }
                                {isEditCommentOpen &&
                                <Grid item xs={12}>
                                    <Box style={{padding: "0 2.25rem 1rem 3rem"}} display="flex" alignContent="center">
                                        <RatingsAddComment
                                            placeholder=""
                                            isEdit={true}
                                            type={"categoryComment"}
                                            criteriaComment={categoryComment}
                                            criteriaId={categoryId}
                                            onCommentsAction={handleCommentsAction}
                                        />
                                    </Box>
                                </Grid>
                                }
                                <Grid item xs={12}>
                                    <List disablePadding component="nav"
                                          aria-label="supplier list"
                                          className={classes.root}>
                                        {(isActionsAllowed && !isSupplierMimic) && commentsLength !== 0 &&
                                        <ListItem divider style={{padding: '.5rem 0rem'}} key={"-1"}>
                                            <Grid container alignItems="center">
                                                <Grid item xs={1} style={{
                                                    maxWidth: '5%'
                                                }}>
                                                    <IconButton aria-label="visibility" disabled>
                                                        <VisibilityIcon/>
                                                    </IconButton>
                                                </Grid>
                                                <Grid item xs={11}>
                                                    <Typography variant="label" size="md">
                                                        {COMMENT_VISIBLE_TITLE}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </ListItem>
                                        }
                                        {categoryCommentsData && categoryCommentsData.map((categoryCommentObj, index) => {
                                            return (
                                                <>
                                                    <RatingCommentDisplay
                                                        index={index}
                                                        criteriaComment={categoryCommentObj}
                                                        suppliers={suppliers}
                                                        loggedInUser={loggedInUser}
                                                        isDivider={categoryCommentsData.length !== index + 1}
                                                        isActionsAllowed={isActionsAllowed}
                                                        onCommentsAction={handleCommentsAction}
                                                        type="categoryComments"
                                                        categoryId={categoryId}
                                                        isSupplierMimic={isSupplierMimic}
                                                    />
                                                </>
                                            )
                                        })}
                                        {comments && comments.map((item, index) => {
                                                const commentData = item.comments.filter(comment => parseInt(comment.categoryId) === categoryId)
                                                return (
                                                    <React.Fragment key={index}>
                                                        {commentData.length !== 0 &&
                                                        <RatingsGeneralComments
                                                            feedback={item}
                                                            key={index}
                                                            commentData={commentData}
                                                            isActionsAllowed={isActionsAllowed}
                                                            isAddCommentOpen={isAddCommentOpen}
                                                            isEditCommentOpen={isEditCommentOpen}
                                                            updateVisibilityState={handleGeneralCommentsUpdate}
                                                            isSupplierMimic={isSupplierMimic}/>
                                                        }
                                                    </React.Fragment>
                                                )
                                            }
                                        )}
                                    </List>
                                </Grid>
                            </Grid>
                            :
                            <Grid container alignItems="center">
                                {isAddCommentOpen &&
                                <Grid item xs={12}>
                                    <Box style={{padding: "0 2.25rem 1rem 3rem"}} display="flex" alignContent="center">
                                        <RatingsAddComment
                                            placeholder=""
                                            criteriaId={categoryId}
                                            onCommentsAction={handleCommentsAction}
                                        />
                                    </Box>
                                </Grid>
                                }
                                {isEditCommentOpen &&
                                <Grid item xs={12}>
                                    <Box style={{padding: "0 2.25rem 1rem 3rem"}} display="flex" alignContent="center">
                                        <RatingsAddComment
                                            placeholder=""
                                            isEdit={true}
                                            type={"categoryComment"}
                                            criteriaComment={categoryComment}
                                            criteriaId={categoryId}
                                            onCommentsAction={handleCommentsAction}
                                        />
                                    </Box>
                                </Grid>
                                }
                                <Grid item xs={12}>
                                    <List disablePadding component="nav"
                                          aria-label="supplier list"
                                          className={classes.root}>
                                        {(isActionsAllowed && !isSupplierMimic) && (categoryCommentsData && categoryCommentsData.length !== 0) &&
                                        <ListItem divider style={{padding: '.5rem 0rem'}} key={"-1"}>
                                            <Grid container alignItems="center">
                                                <Grid item xs={1} style={{
                                                    maxWidth: '5%'
                                                }}>
                                                    <IconButton aria-label="visibility" disabled>
                                                        <VisibilityIcon/>
                                                    </IconButton>
                                                </Grid>
                                                <Grid item xs={11}>
                                                    <Typography variant="label" size="md">
                                                        {COMMENT_VISIBLE_TITLE}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </ListItem>
                                        }
                                        {categoryCommentsData && categoryCommentsData.map((categoryCommentObj, index) => {
                                            return <RatingCommentDisplay
                                                index={index}
                                                key={categoryCommentObj.id}
                                                criteriaComment={categoryCommentObj}
                                                suppliers={suppliers}
                                                loggedInUser={loggedInUser}
                                                isDivider={categoryCommentsData.length !== index + 1}
                                                isActionsAllowed={isActionsAllowed}
                                                onCommentsAction={handleCommentsAction}
                                                type="categoryComments"
                                                categoryId={categoryId}
                                                isSupplierMimic={isSupplierMimic}
                                            />;
                                        })}
                                        <Box mt={2} ml={8} mb={2}>
                                            {filteredSuppliers.map((supplierData) => {
                                                return (
                                                    <CardContent
                                                        style={{padding: 0, marginTop: 10}}
                                                        key={supplierData.supplierNumber}>
                                                        <div className={classes.root}>
                                                            <Accordion
                                                                expanded={expandedComments === `panel${supplierData.supplierNumber}`}
                                                                onChange={handleChangeComment(`panel${supplierData.supplierNumber}`)}>
                                                                <AccordionSummary
                                                                    className={classes.accordionSummary}
                                                                    classes={{
                                                                        expandIcon: classes.expandIcon,
                                                                        content: classes.nestedContent,
                                                                        expanded: classes.expanded
                                                                    }}
                                                                    expandIcon={<ExpandMoreIcon/>}
                                                                    aria-controls="panel1bh-content"
                                                                    id="panel1bh-header"
                                                                >
                                                                    <Grid item xs={8}>
                                                                        <Typography fontWeight="semibold">
                                                                            {supplierData.supplierName} - {parseInt(supplierData.supplierNumber)}
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={4}>
                                                                        <Box display="flex"
                                                                             justifyContent="flex-end">
                                                                            <Typography color="tertiary" size="sm">
                                                                                {commentsCount = (isActionsAllowed && !isSupplierMimic) ? (generalComments.filter(item => item.supplierNumber === supplierData.supplierNumber).map(item =>
                                                                                        item.comments.filter(comment => parseInt(comment.categoryId) === categoryId)).flat().length) :
                                                                                    (generalComments.filter(item => item.supplierNumber === supplierData.supplierNumber).map(item =>
                                                                                        item.comments.filter(comment => {
                                                                                            return parseInt(comment.categoryId) === categoryId && comment.isCommentVisible
                                                                                        })).flat().length)
                                                                                }
                                                                                {commentsCount === 1 ? ' Comment' : ' Comments'}
                                                                            </Typography>
                                                                        </Box>
                                                                    </Grid>
                                                                </AccordionSummary>
                                                                <AccordionDetails className={classes.accordionDetails}>
                                                                    <Grid container>
                                                                        <Grid item xs={12}>
                                                                            <List disablePadding component="nav"
                                                                                  aria-label="comments card"
                                                                                  className={classes.root}>
                                                                                {(isActionsAllowed && !isSupplierMimic) &&
                                                                                <ListItem divider
                                                                                          style={{padding: '.5rem 0rem'}}
                                                                                          key={"-2"}>
                                                                                    <Grid container alignItems="center">
                                                                                        <Grid item xs={1} style={{
                                                                                            maxWidth: '5%'
                                                                                        }}>
                                                                                            <IconButton
                                                                                                aria-label="visibility"
                                                                                                disabled>
                                                                                                <VisibilityIcon/>
                                                                                            </IconButton>
                                                                                        </Grid>
                                                                                        <Grid item xs={11}>
                                                                                            <Typography variant="label"
                                                                                                        size="md">
                                                                                                {COMMENT_VISIBLE_TITLE}
                                                                                            </Typography>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </ListItem>
                                                                                }
                                                                                {comments && comments.map((item, index) => {
                                                                                    if (item.supplierNumber === supplierData.supplierNumber) {
                                                                                        const commentData = (isActionsAllowed && !isSupplierMimic) ?
                                                                                            item.comments.filter(comment => parseInt(comment.categoryId) === categoryId) :
                                                                                            item.comments.filter(comment => {
                                                                                                return parseInt(comment.categoryId) === categoryId && comment.isCommentVisible
                                                                                            })
                                                                                        return (
                                                                                            <React.Fragment key={index}>
                                                                                                {commentData.length !== 0 &&
                                                                                                <RatingsGeneralComments
                                                                                                    feedback={item}
                                                                                                    key={index}
                                                                                                    itemIndex={index}
                                                                                                    commentData={commentData}
                                                                                                    isActionsAllowed={isActionsAllowed}
                                                                                                    isAddCommentOpen={isAddCommentOpen}
                                                                                                    isEditCommentOpen={isEditCommentOpen}
                                                                                                    updateVisibilityState={handleGeneralCommentsUpdate}/>
                                                                                                }
                                                                                            </React.Fragment>
                                                                                        )
                                                                                    }
                                                                                    return null;
                                                                                })}
                                                                            </List>
                                                                        </Grid>
                                                                    </Grid>
                                                                </AccordionDetails>
                                                            </Accordion>
                                                        </div>
                                                    </CardContent>
                                                )
                                            })}
                                        </Box>
                                    </List>
                                </Grid>
                            </Grid>
                        }
                    </AccordionDetails>
                </Accordion>
            </div>
        </CardContent>
    );
}
